import React from "react";
import TenantProfilesList from "../../components/admin/TenantProfilesList";

const TenantProfilesListPage = () => {
  return <TenantProfilesList />;
};

export default TenantProfilesListPage;
